import React from 'react';
import { Button } from 'reactstrap';

export const PendingButton = ({ pending, disabled, children, ...props }) => (
  <Button disabled={pending || disabled} {...props}>
    {!!pending && <span className="fa fa-fw fa-spin fa-spinner mr-1" />}
    {children}
  </Button>
);

export default PendingButton;



// WEBPACK FOOTER //
// ./src/components/common/PendingButton.jsx